import { useState } from 'react';
import useClient from 'api/client';
import { useAlert } from 'components/message/AlertContext';
import { DatasetEditProps } from 'types/Forms';
import updateDataset from 'api/Dataset/updateDataset';
import { useParams } from 'react-router-dom';

interface UseDatasetEditProps {
    datasetUri?: string;
}
export default function useDatasetEdit({ datasetUri }: UseDatasetEditProps) {
    const params = useParams();
    const client = useClient() as any;
    const { openAlert } = useAlert();
    const [loading, setLoading] = useState(false);
    const uri = datasetUri === undefined ? params.uri : datasetUri;

    const submitDatasetChanges = async (
        formData: DatasetEditProps,
        onClose: VoidFunction,
    ) => {
        if (uri !== undefined) {
            try {
                setLoading(true);
                const response = await client?.mutate(
                    updateDataset({ input: formData, datasetUri: uri }),
                );
                if (!response.errors) {
                    openAlert({
                        message: `Dataset information has been updated`,
                        severity: 'success',
                    });
                } else {
                    openAlert({
                        message:
                            'We encountered an error while updating your dataset information, please try again later',
                        severity: 'alert',
                    });
                }
            } finally {
                setLoading(false);
                onClose();
            }
        }
    };

    return { loading, submitDatasetChanges };
}
